import parsePhoneNumber from '../parsePhoneNumber/parsePhoneNumber';

/**
 * Copies formatted phone number to clipboard and shows success alert
 */
const handleClipboardCopy = async (formattedPhone: string): Promise<void> => {
  try {
    await navigator.clipboard.writeText(formattedPhone);
    // eslint-disable-next-line no-alert
    alert('Phone number copied to clipboard');
  } catch (error) {
    // eslint-disable-next-line no-alert
    alert(`Unable to copy. Phone number: ${formattedPhone}`);
  }
};

/**
 * Opens phone dialer with the provided phone number
 */
const handlePhoneCall = (formattedPhone: string): void => {
  const digitsOnly = formattedPhone.replace(/\D/g, '');

  const telLink = `tel:+1${digitsOnly}`;

  window.location.href = telLink;
};

/**
 * Opens SMS app with the provided phone number
 */
const handleSendSMS = (formattedPhone: string): void => {
  const digitsOnly = formattedPhone.replace(/\D/g, '');

  const smsLink = `sms:+1${digitsOnly}`;

  window.location.href = smsLink;
};

/**
 * Handles phone number interaction based on screen size:
 * - Desktop/Tablet (≥768px): Copies formatted phone number to clipboard and shows alert
 * - Mobile (<768px): Opens phone dialer using tel: protocol
 *
 * @param phoneNumber - Phone number as string or number to call or copy
 * @returns void
 */
export const callPhoneNumber = (phoneNumber: string | number): void => {
  const phoneString =
    typeof phoneNumber === 'number' ? phoneNumber.toString() : phoneNumber;

  const parsedPhone = parsePhoneNumber(phoneString);

  if (!parsedPhone) {
    // eslint-disable-next-line no-alert
    alert('Invalid phone number provided.');
    return;
  }

  const isDesktopOrTablet = window.innerWidth >= 768;

  if (isDesktopOrTablet) {
    handleClipboardCopy(parsedPhone);
  } else {
    handlePhoneCall(parsedPhone);
  }
};

/**
 * Handles SMS interaction based on screen size:
 * - Desktop/Tablet (≥768px): Copies formatted phone number to clipboard and shows alert
 * - Mobile (<768px): Opens SMS app using sms: protocol
 *
 * @param phoneNumber - Phone number as string or number to send SMS to or copy
 * @returns void
 */
export const sendSMS = (phoneNumber: string | number): void => {
  const phoneString =
    typeof phoneNumber === 'number' ? phoneNumber.toString() : phoneNumber;

  const parsedPhone = parsePhoneNumber(phoneString);

  if (!parsedPhone) {
    // eslint-disable-next-line no-alert
    alert('Invalid phone number provided.');
    return;
  }

  const isDesktopOrTablet = window.innerWidth >= 768;

  if (isDesktopOrTablet) {
    handleClipboardCopy(parsedPhone);
  } else {
    console.log('sendSMS', parsedPhone);
    handleSendSMS(parsedPhone);
  }
};
